import { Avatar, Box, Card, CardContent, Skeleton, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'

type StatCardProps = {
    icon?: string,
    title: string,
    value: number | string,
    unit?: string,
    isLoading: boolean,
    children?: React.ReactNode
}

function StatCard({ icon, title, value, unit, isLoading, children }: StatCardProps) {
    return (
        <Box display={'flex'} justifyContent={'space-between'} gap={1}>
            {
                icon && <Card sx={{ p: 2, width: '65px', height: '65px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="icon" >
                        <span className={`eq-${icon} eq-icon-2`}>
                            <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
                    </div>
                </Card>
            }

            <Box display={'flex'} flexDirection={'column'} justifyContent={'space-evenly'} >
                <Typography variant='caption' color={'gray'} fontSize={'14px'}>{title}</Typography>
                {
                    isLoading ? <Skeleton variant='text'></Skeleton> : <Typography variant='subtitle2' fontSize={'18px'} gap={1} display={'flex'}>{value} {unit}
                    </Typography>
                }
                {
                    children
                }

            </Box>

        </Box>
    )
}

export default StatCard